import { useAtom } from "jotai";
import { createContext, useState } from "react";
import { logout } from "../pages/auth/signIn/login/loginService";
import {
  avatarAtom,
  publisherNameAtom,
  selectedPublisherIdAtom,
  userFullNameAtom,
  userRoleAtom,
} from "../atom/atoms";

export const AuthContext = createContext(null);

const initialState = {
  isAuthenticated: window.sessionStorage.getItem("user") ? true : false,
  isInitialized: false,
  isAdmin: false,
  routes: null,
  user: null,
  customer: null,
};

const AuthProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [, setAvatar] = useAtom(avatarAtom);
  const [, setSelectedPublisherId] = useAtom(selectedPublisherIdAtom);
  const [, setPublisherName] = useAtom(publisherNameAtom);
  const [, setUserRole] = useAtom(userRoleAtom);
  const [, setUserFullName] = useAtom(userFullNameAtom);

  const setAuthState = (
    user = null,
    customer = null,
    routes = null,
    isAuthenticated = false,
    isInitialized = false,
    isAdmin = false
  ) => {
    setState({
      ...state,
      user,
      customer,
      routes,
      isAuthenticated,
      isInitialized,
      isAdmin,
    });
  };

  const logOut = async () => {
    setAvatar(null);
    setSelectedPublisherId(null);
    setPublisherName(null);
    setUserRole(null);
    setUserFullName(null);
    sessionStorage.clear();
    setState({
      isAdmin: false,
      isAuthenticated: false,
      isInitialized: false,
      user: null,
      customer: null,
      routes: null,
    });

    try {
      await logout();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        state,
        setAuthState,
        logOut,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
